import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export interface OnlyFansTransactionsDailyStats {
    date: string;
    timezone: string;
    totalAmount: number;
    totalNet: number;
    totalTip: number;
    totalMessage: number;
    totalPost: number;
    totalResubscription: number;
    totalSubscription: number;
    totalStream: number;
    transactionsCount: number;
}

const useTransactionsDailyStats = (subscriberId: string | undefined, date: string | null, timezone: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    const fetchDailyStats = async (): Promise<OnlyFansTransactionsDailyStats | null> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !subscriberId || !date || !timezone) {
            return null;
        }

        const query: string = `${settingsContext.routes.transactions.base}${subscriberId}/dailyStats?${new URLSearchParams({
            date,
            timezone,
        })}`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                handleHttpError(error, dialog);

                return null;
            });

        return data;
    };

    return useQuery(['transactionsDailyStats', subscriberId, date, timezone], fetchDailyStats, {
        refetchOnWindowFocus: false,
        staleTime: 60 * 1000,
        enabled: !!(userContext.jwtToken && settingsContext.apiKey && subscriberId && date && timezone),
    });
};

export default useTransactionsDailyStats;
